// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#fee_schedule_program_form label,#fee_schedule_program_form .service_type-select_field{font-style:normal;color:#374151;font-weight:400;font-size:14px;text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
